<app-loading-component *ngIf="isShowLoadingComponent"></app-loading-component>


// WEBPACK FOOTER //
// ./src/app/intelligent-transfer/intelligent-transfer.component.html